const createApiSlice = (set) => ({
  api: {
    loading: false,
    error: null,
  },
});

export default createApiSlice;
